import { connect } from '~/store';
import { Config } from '~/helpers/types/Config';

/** Store helper: providers the app configuration. */
export default (component: any): (props: any) => any => (
  connect(({ config }: { config: Config }) => ({ config }))(component)
);
